<template>
	<div class="search-input" :class="{ opened: open }">
		<i class="icon icon-search" @click="openSearch()"></i>
		<input
			type="text"
			ref="searchInput"
			id="searchInput"
			class="form-control"
			placeholder="Buscar"
			v-model="search"
			@input="onSearch()"
			autocomplete="off"
		/>
		<div class="btn btn-light btn-clear-filter" @click="close()">
			<i class="icon icon-close"></i>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		opened: {
			default: false,
			type: Boolean
		}
	},
	data() {
		return {
			open: false,
			search: ""
		}
	},
	beforeMount() {
		if (this.opened) {
			this.openSearch()
		}
	},
	methods: {
		openSearch() {
			this.open = true
			this.$nextTick(() => {
				document.getElementById("searchInput").focus()
			})
		},
		close() {
			this.open = false
			this.$emit("closed")
		},

		onSearch() {
			this.$emit("changed", this.search)
		}
	}
}
</script>

<style scoped lang="scss">
.search-input {
	background-color: #ffffff00;
	border-radius: 12px;
	position: relative;
	min-width: 42px;
	height: 42px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease-in-out;

	.icon {
	}
	input {
		background: none;
		border: none;
		padding: 4px 8px 4px 12px;
		color: #fff;
	}

	.btn-clear-filter,
	input {
		display: none;
	}

	&.opened {
		position: fixed;

		top: 5px;
		left: 6px;
		right: 6px;
		padding: 0px 12px;

		height: 48px;
		background-color: #383737;
		border-radius: 36px;
		z-index: 10;

		.btn-clear-filter {
			background-color: transparent;
			background-color: transparent;
			display: flex;
			border: none;
			align-items: center;
			justify-content: center;

			.icon {
				filter: invert(1);
				width: 14px;
			}
		}
	}

	&.opened input {
		display: block;
	}
}
</style>
